import { useEffect, useState } from 'react'

/**
 * Becomes true after `ms` while `active` stays true. Resets when `active` clears.
 * Used so a hung commercial fetch cannot leave an Upcoming Escape row gated forever.
 */
function useLoadTimeout(active: boolean, ms: number): boolean {
  const [timedOut, setTimedOut] = useState(false)

  useEffect(() => {
    if (!active) {
      setTimedOut(false)
      return
    }

    const timeoutId = window.setTimeout(() => setTimedOut(true), ms)
    return () => window.clearTimeout(timeoutId)
  }, [active, ms])

  return timedOut
}

export default useLoadTimeout
